module.exports = __webpack_public_path__ + "img/Group-30.0ad13eb3.webp";